import queryString from 'query-string';

export function generateMapsUrl({
  address,
  coordinates,
}: {
  address?: string;
  coordinates?: google.maps.LatLng | google.maps.LatLngLiteral;
  zoom?: number;
}): string {
  if (coordinates.lat && coordinates.lng) {
    return `https://www.google.com/maps/@?api=1&map_action=map&center=${coordinates.lat}%2C${coordinates.lng}&zoom=20`;
  }
  if (address) {
    return `https://www.google.com/maps/search/?api=1&${queryString.stringify({
      query: address,
    })}`;
  }

  return null;
}
